import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { RichBlockStatus } from '@pure1/data';

/**
 * The four-value block severity, rendered as a pill: a colored dot plus a text label.
 *
 * The label is not optional — FR-026 requires severity to be conveyed by text as well as color,
 * which is why it is literal text in the template rather than a map lookup here.
 */
@Component({
    selector: 'copilot-rich-block-status',
    templateUrl: './rich-block-status.component.html',
    styleUrl: './rich-block-status.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    preserveWhitespaces: false,
})
export class RichBlockStatusComponent {
    readonly status = input.required<RichBlockStatus>();
}
